import React from 'react';

const FeaturedPostItem = ({ title, author, date, description, slug, category, image }) => {
  return (
    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={image} alt="" />
      </div>
      <div className="flex-1 bg-white pb-6 px-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="border-b border-gray-200 text-md font-medium text-secondary">
            <div>{category}</div>
          </p>
          <a href={'blog/' + slug} className="block">
            <h3 className="mt-4 mb-2 text-xl leading-7 font-semibold text-gray-900 hover:text-gray-500 hover:transition ease-in-out duration-200">
              {title}
            </h3>
            <p className="mt-2 text-base leading-6 text-gray-500">{description}</p>
          </a>
        </div>
        <div className="flex items-center">
          <div className="">
            <a className="text-sm leading-5 font-medium text-gray-900">{author}</a>
            <div className="flex text-sm leading-5 text-gray-500">
              <time datetime="2020-03-16">{date}</time>
            </div>
          </div>
          <div className="ml-12">
            <p className="text-md font-medium text-primary-darker hover:text-primary-lighter">
              <a href={'blog/' + slug}>Read More...</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedPostItem;
